(function () {

	'use strict';
	var rootUrl = baseUrl + 'root/headers/';
	angular
		.module('customHeaders', [])
		.run(['$rootScope', function ($rootScope) {
			$rootScope.redirectApp = function (formId, newTab, event) {
				var form = document.getElementById(formId);
				if (newTab && form) {
					form.target = '_blank';
				}
				if (form) form.submit();
				event && event.preventDefault();
			}
		}])
		.directive('customHeaders', function () {
			return {
				replace: true,
				templateUrl: rootUrl + 'header.html',
				restrict: 'E',
				scope: {
				},
				link: function (scope, elem, attrs) {
				},
				controller: ["$scope", "$http", "$sce", "$window", function ($scope, $http, $sce, $window) {
					$scope.miz_domain = pub_domain;
					$scope.olb_domain = olb_domain;
					$scope.lang = incoming_lang || 'en';

					$http({
						method: 'GET',
						url: rootUrl + "content/" + incoming_lang + '.json'
					}).then(function (response) {
						$scope.content = response.data;
					})

					$scope.today = new Date().toLocaleDateString($scope.lang + '-CA', { year: 'numeric', month: 'long', day: 'numeric' });
					$scope.currentYear = new Date().getFullYear();

					//determine active menu item
					switch (baseUrl) {
						case "/":
						case "/apps/my-auto-affordability":
						case "/uaw0/my-auto-affordability":
							$scope.activeId = "tha-header-link";
					}
					$scope.setActiveHeaderItem = function () {
						if ($scope.activeId && document.getElementById($scope.activeId)) {
							document.getElementById($scope.activeId).classList.add('header-menu-active');
							document.getElementById($scope.activeId + "-mob").classList.add('side-menu-active');
						}
					}

					$scope.skipToContent = function () {
						var list = $('h1');
						for (var i = 0; i < list.length; i++) {
							if (isElementInViewport(list[i])) {
								list[i].focus();
								return;
							}
						}
						if (list.length)
							list[0].focus();
					}
					function isElementInViewport(el) {
						if (typeof jQuery === "function" && el instanceof jQuery) {
							el = el[0];
						}
						var rect = el.getBoundingClientRect();
						return (
							rect.top >= 0 &&
							rect.left >= 0 &&
							rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
							rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
							rect.bottom > 0 &&
							rect.right > 0
						);
					}

					$scope.formatPhoneNo = function (input, lang) {
						if (input !== null && input !== undefined) {

							var formatted = "";
							input = input.replace(/[^\/\d]/g, '');
							if (input.length === 11) {
								var country = input.substring(0, 1);
								var area = input.substring(1, 4);
								var front = input.substring(4, 7);
								var end = input.substring(7, 11);
								if (lang == "en") {
									formatted = country + "-" + area + "-" + front + "-" + end;
								}
								else formatted = country + " " + area + " " + front + "-" + end;
							}
							else if (input.length === 10) {
								var area = input.substring(0, 3);
								var front = input.substring(3, 6);
								var end = input.substring(6, 10);
								if (lang == "en") {
									formatted = area + "-" + front + "-" + end;
								}
								else formatted = area + " " + front + "-" + end;
							}
							else formatted = input;
							return formatted;
						}
					}
				}]
			}
		})
		.directive('headerCancel', function () {
			return {
				replace: true,
				restrict: 'E',
				templateUrl: rootUrl + 'cancel-button.tpl.html',
				link: function (scope, element, attrs) {
				}
			}
		})
		.directive('langToggle', function () {
			return {
				replace: true,
				templateUrl: rootUrl + 'lang-toggle.tpl.html',
				restrict: 'E',
				link: function (scope, elem, attrs) {
				}
			}
		})
})();
